import { render, staticRenderFns } from "./printLogisticsRec.vue?vue&type=template&id=5d03fc18&scoped=true&"
import script from "./printLogisticsRec.vue?vue&type=script&lang=js&"
export * from "./printLogisticsRec.vue?vue&type=script&lang=js&"
import style0 from "./printLogisticsRec.vue?vue&type=style&index=0&id=5d03fc18&lang=less&scoped=true&media=print&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d03fc18",
  null
  
)

component.options.__file = "printLogisticsRec.vue"
export default component.exports